module.exports = __webpack_public_path__ + "img/check-blue.a35154ad.svg";